import { createTheme, ThemeProvider } from '@mui/material';
import React from 'react'
import './App.css';
import AuthConsumer from './services/Context/Auth/consumer';
import InfoConsumer from './services/Context/Info/consumer';
import RoutesComp from './services/routes';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF258D',
    },
    secondary: {
      main: '#FAF0E6',
    },
  },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
      <InfoConsumer>
        {v => (<AuthConsumer value={v}>
          {(value) => (
            <RoutesComp value={value} />
          )}
        </AuthConsumer>)}
      </InfoConsumer>
    </ThemeProvider>
  );
}

export default App;
